const CURRENT_ADVERTISER_KEY = 'currentProject';

// 保存する
export const saveCurrentProject = (id: number, name: string) => {
  const project = { id, name };
  localStorage.setItem(CURRENT_ADVERTISER_KEY, JSON.stringify(project));
};

// 取得する（存在しない場合は null を返す）
export const getCurrentProject = (): { id: number; name: string } | null => {
  const json = localStorage.getItem(CURRENT_ADVERTISER_KEY);
  if (!json) return null;

  try {
    const data = JSON.parse(json);
    if (
      typeof data === 'object'
			&& data !== null
			&& typeof data.id === 'number'
			&& typeof data.name === 'string'
    ) {
      return data;
    } else {
      throw new Error('保存データの形式が不正です');
    }
  } catch (e) {
    console.error('ローカルストレージのprojectデータが不正です:', e);
    return null;
  }
};

// 削除する（必要に応じて）
export const removeCurrentProject = () => {
  localStorage.removeItem(CURRENT_ADVERTISER_KEY);
};
